<header height="13vh">
  <div>
    <table width="100vw" >
      <tr style="height:7vh">
          <td align="left" valign="middle" colspan="2" class="section" style="white-space: nowrap">
              <label class="confirmplan">Confirm Plan</label><br />
              <p class="headertext">These are the plans included in your quote. Please review and confirm before continuing. </p>
          </td>
      </tr>
      <tr style="height:3vh" >
          <td align="left" valign="middle" class="section" width="60%"></td>
        <td align="right" valign="middle" class="aside" width="40%" style="white-space: nowrap" > <label class="quotecolor">Quote ID : {{quoteid}}</label> </td>
      </tr>
    </table>
  </div>
</header>
